import { createReducer, on } from '@ngrx/store';

import { GlobalActions } from '@fcom/core/actions';
import { DataUtils } from '@fcom/core/utils';
import { PaxDetailsState } from '@fcom/common/interfaces/booking';

import { PaxDetailsActions } from '../actions';

export const initialState: PaxDetailsState = Object.seal({
  passengers: [],
  additionalEmails: [],
});

const reducer = createReducer(
  initialState,
  on(PaxDetailsActions.setPaxDetails, (state, { passengers }) => ({
    ...state,
    passengers,
  })),
  on(PaxDetailsActions.setSinglePaxDetails, (state, { passenger }) => ({
    ...state,
    passengers: state.passengers.map((p) => (p.travelerId === passenger.travelerId ? passenger : p)),
  })),
  on(PaxDetailsActions.setCorporateCode, (state, { corporateCode }) => ({
    ...state,
    corporateCode,
  })),
  on(PaxDetailsActions.setAdditionalEmails, (state, { additionalEmails }) => ({
    ...state,
    additionalEmails,
  })),
  on(PaxDetailsActions.reset, () => initialState),
  on(GlobalActions.confirmation, (state) =>
    DataUtils.wrap(state).deleteIn('corporateCode').setIn(['passengers', 0, 'joinFinnairPlus'], false).value()
  )
);

export function paxDetailsReducer(
  state: PaxDetailsState,
  action: PaxDetailsActions.ActionsUnion | GlobalActions.ActionsUnion
) {
  return reducer(state, action);
}
